<header class="header" [ngClass]="{'without-navbar': getRouterUrl() == '/'}">
    <mat-toolbar>
        <button #menuButton class="header__menu" mat-icon-button color="primary" aria-label="Menu" (click)="snav.toggle()">
            <mat-icon>menu</mat-icon>
        </button>
        <a id="logo" class="header__logo" [routerLink]="['/']"><img src="https://wickedlist.com/assets/img/logo.png" (load)="upAndCheckLoadedCount()"/></a>
        <div class="header__linkPremium">
          <a routerLink="/compare-versions" mat-raised-button color="primary" *ngIf="showUpgradeToPremiumLine">Upgrade</a>
        </div>
    </mat-toolbar>
    <mat-sidenav-container class="sidenavContainer header__sidenavContainer">
        <mat-sidenav #snav [fixedInViewport]="true" fixedTopGap="56">
        <mat-nav-list class="mobileMenu header__mobileMenu">
            <div class="mobileMenu__box">
                <h4 class="mobileMenu__title">Informations</h4>
                <ul class="mobileMenu__list">
                  <li class="mobileMenu__item">
                    <a mat-raised-button href="{{strBlogUrl}}about-us">About Us</a>
                  </li>
                  <li class="mobileMenu__item">
                    <a mat-raised-button href="{{strBlogUrl}}contact-us">Contact Us</a>
                  </li>
                  <li class="mobileMenu__item">
                    <a mat-raised-button href="{{strBlogUrl}}privacy-policy/">Privacy Policy</a>
                  </li>
                  <li class="mobileMenu__item">
                    <a mat-raised-button href="{{strBlogUrl}}terms-of-use/">Terms And Conditions</a>
                  </li>
                </ul>

              </div>
              <div class="mobileMenu__box">
                <h4 class="mobileMenu__title">WickedList</h4>
                <ul class="mobileMenu__list">
                  <li class="mobileMenu__item" *ngIf="enableCompareVersion">
                    <a mat-raised-button style="cursor: pointer" (click)="showCompareVersionsDialog()">Compare versions</a>
                  </li>
                  <li class="mobileMenu__item">
                    <a mat-raised-button href="{{ enableAdvertiseWithUs ? '/adv-with-us' : '/b/contact-us'}}" (click)="closeSnav()">Advertise With Us</a>
                  </li>

                  <li class="mobileMenu__item" *ngIf="enableSubscription">
                    <a mat-raised-button [routerLink]="['/subscription-information']" (click)="closeSnav()" >Subscription</a>
                  </li>
                </ul>
              </div>
              <div class="mobileMenu__box">
                <h4 class="mobileMenu__title">Quick Links</h4>
                <ul class="mobileMenu__list">
                  <li class="mobileMenu__item">
                    <a mat-raised-button href="{{strBlogUrl}}blog/">Blog</a>
                  </li>
                  <li class="mobileMenu__item">
                    <a mat-raised-button href="{{strBlogUrl}}dating-tips/">Dating Tips</a>
                  </li>
                  <li class="mobileMenu__item">
                    <a mat-raised-button color="primary" routerLink="/ad-writter" (click)="closeSnav()"  *ngIf="enableLetOurPros">Let one of our Pros write Your ad for You</a>
                  </li>
                  <!-- <li class="mobileMenu__item">
          <a mat-raised-button href="{{strBlogUrl}}pricing-table/">Pricing table (example)</a>
        </li>-->
                </ul>
              </div>
        </mat-nav-list>
        </mat-sidenav>
    </mat-sidenav-container>
    <div class="socialBar header__socialBar">
      <ul class="et-social-icons">
          <li class="et-social-icon et-social-facebook">
            <a rel="noreferrer" href="https://www.facebook.com/WickedListDating" class="icon" target="_blank">
              <span>Facebook</span>
            </a>
          </li>
          <li class="et-social-icon et-social-twitter">
            <a rel="noreferrer" href="https://twitter.com/WickedList" class="icon" target="_blank">
              <span>Twitter</span>
            </a>
          </li>
          <li class="et-social-icon et-social-instagram">
            <a rel="noreferrer" href="https://www.instagram.com/wickedlistdating/" class="icon" target="_blank">
              <span>Instagram</span>
            </a>
          </li>
        </ul>
    </div>
    <div class="navBar header__navBar" *ngIf="getRouterUrl() != '/'">
        <i class="navBar__btBack material-icons" (click)="locationBack()" *ngIf="getRouterUrl() != '/' && router.navigated" >keyboard_backspace</i>
        <span class="navBar__pageName">{{pageName}}</span>
    </div>
</header>
